<template>
    <div class="search-nodata">
      <div class="no-data-content">
        <img
          src="https://static.wecity.qq.com/h5/2020-2/search-result-4d569d81f2543c5f9c86d840b29d28a0.png"
        />
        <h4>暫無結果</h4>
      </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
.no-data {
    width: 100%;
    height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    
  }
  .no-data-content {
    padding: 0 50px;
    text-align: center;
    transform: translate3d(0, -30%, 0);
    
    img {
        width: 90px;
        height: 90px;
        margin: 0 auto;
        display: block;
    }
    h4 {
        font-size: 16px;
        line-height: 32px;
        font-weight: bold;
        color: #333333;
    }
    p {
        font-size: 14px;
        line-height: 22px;
        color: #666666;
    }
    .btn {
      height: 45px;
      margin-top: 30px;
      line-height: 45px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      background: #5675F1;
      border-radius: 45px;
    }
  }
  .search-nodata {
    width: 100%;
    padding-top: 90px;
    .no-data-content {
      transform: translate3d(0,0,0);
    }
  }
</style>